import { Component } from '@angular/core';

@Component({
  selector: 'app-form-spinner',
  templateUrl: './form-spinner.component.html',
  styleUrls: ['./form-spinner.component.css'],standalone:false
})
export class FormSpinnerComponent {

}
